"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const letterSpacings = {
    "tight": "-0.04em",
    "wide": "0.06em",
    "regular": "0em"
};
exports.default = letterSpacings;
//# sourceMappingURL=letterSpacings.js.map